import OpenDialogAction from './OpenDialogAction';

export default OpenDialogAction.extend({
  isApplicable: function (selectedItems) {   
    return selectedItems[0].pagechanged === 'true' || selectedItems[0].pagechangedCleared === 'true';
   
  }
});